<div class="endereco-compacto" *ngIf="compacto; else enderecoPadrao">
  <div class="endereco-texto" [class.removido]="endereco.removido">
    <span class="endereco-descricao" *ngIf="endereco.descricao">{{endereco.descricao}}</span>
    <strong>{{endereco.logradouro}}<ng-container *ngIf="endereco.numero">, {{endereco.numero}}</ng-container></strong>
    <span *ngIf="endereco.complemento">{{endereco.complemento}}</span>
    <span *ngIf="endereco.bairro">{{endereco.bairro}}</span>
    <span *ngIf="endereco.cidade?.nome || endereco.estado?.sigla || endereco.cep">{{endereco.cidade?.nome}}<ng-container *ngIf="endereco.estado?.sigla"> / {{endereco.estado.sigla}}</ng-container><ng-container *ngIf="endereco.cep"> · {{endereco.cep}}</ng-container></span>
  </div>
  <button type="button" class="endereco-editar" (click)="abraModalEditarEndereco()" *ngIf="!endereco.removido"
          [attr.aria-label]="'Editar endereço: ' + (endereco.descricao || endereco.logradouro)" title="Editar endereço">
    <i class="fe-edit" aria-hidden="true"></i>
  </button>
</div>
<ng-template #enderecoPadrao>
<span [class.removido]="endereco.removido"><i class="fas fa-map-marker-alt mr-1"></i>
  {{(endereco.descricao) ? (endereco.descricao + ': ') : ''}} {{endereco.logradouro | json}},
  {{endereco.numero}}{{endereco.complemento != null ? ", " + endereco.complemento : ""}} -
  {{endereco.bairro}}  {{endereco.cep}} {{endereco.cidade?.nome}}/{{endereco.estado?.sigla}}
</span>

<i class="fe-edit fa-lg cpointer" (click)="abraModalEditarEndereco()" [hidden]="endereco.removido"></i>
</ng-template>
